import type { IPropertyBag } from '@deity-io/di-data-basics';
import type { IconType, OverridableStringUnion, SvgIconPropsColorOverrides } from '@deity-io/portal-ui';
import { Icon, Tooltip } from '@deity-io/portal-ui';
import type { FC } from 'react';

export type IThemeColor = OverridableStringUnion<
  'inherit' | 'action' | 'disabled' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
  SvgIconPropsColorOverrides
>;

interface IconButtonProps {
  disabled?: boolean;
  tooltip?: string;
  icon: IconType;
  onClick?: () => void;
  color?: IThemeColor;
  sx?: IPropertyBag;
}

export const IconButton: FC<IconButtonProps> = ({ disabled = false, tooltip, icon, onClick, color, sx = {} }) => {
  const newSx: IPropertyBag = {
    opacity: '0.7',
    borderStyle: 'none',
    borderWidth: '1px',
    // '&:active': {
    //   borderColor: undefined,
    //   borderStyle: 'inset',
    //   opacity: '1'
    // },
    '&:hover': {
      borderColor: undefined,
      borderStyle: 'outset',
      opacity: '1'
    },
    ...sx
  };

  if (disabled) {
    newSx.cursor = 'not-allowed';
  } else {
    newSx.cursor = 'pointer';
  }

  const iconElement = (
    <Icon
      color={color || (disabled ? 'disabled' : 'primary')}
      sx={newSx}
      icon={icon}
      onClick={() => {
        if (onClick && !disabled) {
          onClick();
        }
      }}
      // onMouseDown={e => {
      //   console.log(e);
      //   e.target.style.borderStyle = 'inset';
      // }}
    />
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{iconElement}</Tooltip>;
  }

  return iconElement;
};
